import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-object-category-controller',
  templateUrl: './object-category-controller.component.html',
  styleUrls: ['./object-category-controller.component.css']
})
export class ObjectCategoryControllerComponent implements OnInit {

  objectCategoryList:any = [];
  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  isLoading: any = false
  id: any

  addForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;

  updateForm: any | FormGroup
  isEdit: boolean = false
  singleObjectCategoryData: any = [];

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";

  constructor(
    private generic_service: GenericService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.addForm = this.fb.group({
      categoryDescription: [''],
      depreciationRate: [],
      categoryName: ['',[Validators.required]]
    })
    this.updateForm = this.fb.group({
      categoryDescription: [''],
      depreciationRate: [],
      categoryName: ['',[Validators.required]]
    })
    this.getAllObjectCategory();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page+1;
  }

  getAllObjectCategory(){
    this.isLoading = true
    this.generic_service.getAllObjectCategory().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectCategoryList = res.response
        this.totalRecords = res.response.length
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getObjectCategoryById(objectCategoryId:any){
    this.generic_service.getObjectCategoryById(objectCategoryId).subscribe(
      (response:any)=>{
        this.singleObjectCategoryData = []
        this.singleObjectCategoryData.push(response.response)
        this.updateForm.patchValue({
          categoryDescription: response.response.categoryDescription,
          categoryName: response.response.categoryName,
          depreciationRate: response.response.depreciationRate
        })
        this.isEdit = true
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalAdd")?.click()
    document.getElementById("closeModalUpdate")?.click()
    document.getElementById("closeModalDelete")?.click()
  }

  deleteObjectCategory(){
    this.generic_service.deleteObjectCategory(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllObjectCategory();
        this.cancelModel();
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any,list: any){
    this.id = id
    this.recordId = list.objectCategoryId
    this.recordName = list.categoryName
  }
  
  clearData(){
    this.recordId = "";
    this.recordName = "";
  }


  refreshAll(){
    this.pageNumber = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllObjectCategory()
  }

  getAllObjectCategorysByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getAllObjectCategorysByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
        this.objectCategoryList = []
        this.totalRecords = 0
          return

        }
        this.objectCategoryList = res.response
        this.totalRecords = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }


  addObjectCategory(){
    this.formSubmit = true;
    if(!this.addForm.valid){
      this.toastr.error("Please fill in all required fields");
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "categoryName": this.addForm.get('categoryName').value,
      "categoryDescription": this.addForm.get('categoryDescription').value,
      "depreciationRate":this.addForm.get('depreciationRate').value,
      "cid": Number(this.cid),
    }

    console.log(body)
    this.generic_service.addObjectCategory(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.addForm.reset()
        this.cancelModel()
        this.getAllObjectCategory();

        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  updateObjectCategory(){
    this.formSubmit = true;
    if(!this.updateForm.valid){
      this.toastr.error("Please fill in all required fields");
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.singleObjectCategoryData[0].id,
      "objectCategoryId": this.singleObjectCategoryData[0].objectCategoryId,
      "categoryName": this.updateForm.get('categoryName').value,
      "depreciationRate":this.updateForm.get('depreciationRate').value,
      "categoryDescription": this.updateForm.get('categoryDescription').value,
      "cid": Number(this.cid),
    }
    console.log(body)
    this.generic_service.updateObjectCategory(body).subscribe(
      (response:any)=>{
        this.isEdit = false
        this.getAllObjectCategory();
        this.cancelModel()
        this.formSubmit = false;
        this.updateForm.reset()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

}